module.exports = __webpack_public_path__ + "img/Group 12567_3@2x.acbfa7b2.png";